import { showErrorMessage } from 'actions/messages';
import { directoriesApi } from 'services/api/directories-api';
import { projectContributorsApi } from 'services/api/project-contributors-api';
import { serviceProvidersApi } from 'services/api/service-providers-api';
import {
  DIRECTORY_SET,
  DIRECTORY_PDF_SET,
  SHOW_NEW_CONTRIBUTOR_MODAL_SET,
  SHOW_EDIT_USER_MODAL_SET,
  NEW_CONTRIBUTOR_MODAL_INIT,
  SERVICE_PROVIDER_USERS_SET,
  PROJECT_CONTRIBUTORS_UPDATE,
  SHOW_NEW_COMPANY_FORM_SET,
  SHOW_SELECT_USERS_FORM_SET,
  SHOW_INVITE_USER_FORM_SET,
  SHOW_DIRECTORY_PDF_VIEWER_SET,
  CURRENT_CONTRIBUTOR_SET,
  NEW_CONTRIBUTOR_TYPE_SET,
  CONTRIBUTOR_SETTINGS_TOGGLE,
  USER_SETTINGS_TOGGLE,
  PROJECT_CONTRIBUTORS_DELETE,
  PROJECT_CONTRIBUTORS_UPDATE_WITH_EDIT_USER,
} from 'components/admin/projects/details/project-directory/store/action-types';

export function loadDirectorySuccess(directory) {
  return {
    type: DIRECTORY_SET,
    payload: directory,
  };
}

export function loadDirectoryRequest(projectId) {
  return (dispatch) => {
    return directoriesApi.getDirectory(projectId).then((response) => {
      if (response.ok) {
        dispatch(loadDirectorySuccess(response.directory));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadDirectoryPdfSuccess(directoryPdf) {
  return {
    type: DIRECTORY_PDF_SET,
    payload: directoryPdf,
  };
}

export function loadDirectoryPdfRequest(projectId) {
  return (dispatch) => {
    return directoriesApi.getDirectoryPdf(projectId).then((response) => {
      if (response.ok) {
        dispatch(loadDirectoryPdfSuccess(response.directoryPdf));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function searchDirectory(projectId) {
  return (dispatch) => {
    return directoriesApi.getDirectory(projectId).then((response) => {
      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function setShowNewContributorModal(showNewContributorModal) {
  return {
    type: SHOW_NEW_CONTRIBUTOR_MODAL_SET,
    payload: showNewContributorModal,
  };
}

export function setShowEditUserModal(showEditUserModal, user) {
  return {
    type: SHOW_EDIT_USER_MODAL_SET,
    payload: { showEditUserModal, user },
  };
}

export function initNewContributorModal() {
  return {
    type: NEW_CONTRIBUTOR_MODAL_INIT,
  };
}

export function setShowSelectUsersForm(showSelectUsersForm) {
  return {
    type: SHOW_SELECT_USERS_FORM_SET,
    payload: showSelectUsersForm,
  };
}

export function setShowInviteUserForm(showInviteUserForm) {
  return {
    type: SHOW_INVITE_USER_FORM_SET,
    payload: showInviteUserForm,
  };
}

export function setShowDirectoryPdfViewer(showDirectoryPdfViewer) {
  return {
    type: SHOW_DIRECTORY_PDF_VIEWER_SET,
    payload: showDirectoryPdfViewer,
  };
}

export function setCurrentContributor(contrib) {
  return {
    type: CURRENT_CONTRIBUTOR_SET,
    payload: contrib,
  };
}

export function fetchServiceProviders(type, byName, page) {
  return (dispatch) => {
    return serviceProvidersApi
      .getServiceProviders(type, byName, page)
      .then((response) => {
        if (!response.ok) {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function loadServiceProviderUsersSuccess(users) {
  return {
    type: SERVICE_PROVIDER_USERS_SET,
    payload: users,
  };
}

export function loadServiceProviderUsers(type, serviceProviderId) {
  return (dispatch) => {
    return serviceProvidersApi
      .getServiceProviderUsers(type, serviceProviderId)
      .then((response) => {
        if (response.ok) {
          dispatch(loadServiceProviderUsersSuccess(response.users));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function createProjectContributor(projectId, values) {
  return (dispatch) => {
    return projectContributorsApi
      .createProjectContributor(projectId, values)
      .then((response) => {
        if (response.ok) {
          dispatch(loadDirectoryRequest(projectId));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function updateProjectContributorSuccess(projectContributor) {
  return {
    type: PROJECT_CONTRIBUTORS_UPDATE,
    payload: projectContributor,
  };
}

export function updateProjectContributor(projectId, id, values) {
  return (dispatch) => {
    return projectContributorsApi
      .updateProjectContributor(projectId, id, values)
      .then((response) => {
        if (response.ok) {
          dispatch(
            updateProjectContributorSuccess(response.projectContributor)
          );
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function setShowNewCompanyForm(showNewCompanyForm) {
  return {
    type: SHOW_NEW_COMPANY_FORM_SET,
    payload: showNewCompanyForm,
  };
}

export function createServiceProvider(type, values) {
  return (dispatch) => {
    return serviceProvidersApi
      .createServiceProviderDirectory(type, values)
      .then((response) => {
        if (!response.ok) {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function editUser(values) {
  return (dispatch) => {
    return serviceProvidersApi.editUser(values).then((response) => {
      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      } else {
        dispatch(setShowEditUserModal(false));
        dispatch(updateContributersWithEditUser(response.updatedUser));
      }

      return response;
    });
  };
}

export function updateContributersWithEditUser(user) {
  return {
    type: PROJECT_CONTRIBUTORS_UPDATE_WITH_EDIT_USER,
    payload: user,
  };
}

export function setNewContributorType(type) {
  return {
    type: NEW_CONTRIBUTOR_TYPE_SET,
    payload: type,
  };
}

export function toggleContributorSettings(id) {
  return {
    type: CONTRIBUTOR_SETTINGS_TOGGLE,
    payload: id,
  };
}

export function toggleUserSettings(id) {
  return {
    type: USER_SETTINGS_TOGGLE,
    payload: id,
  };
}

export function projectContributorDeleteSuccess(id) {
  return {
    type: PROJECT_CONTRIBUTORS_DELETE,
    payload: id,
  };
}

export function deleteProjectContributor(projectId, id) {
  return (dispatch) => {
    return projectContributorsApi
      .destroyProjectContributor(projectId, id)
      .then((response) => {
        if (response.ok) {
          dispatch(projectContributorDeleteSuccess(id));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function inviteUser(type, id, values) {
  return (dispatch) => {
    return serviceProvidersApi.inviteUser(type, id, values).then((response) => {
      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function sendInvite(user) {
  return (dispatch) => {
    return serviceProvidersApi.sendInvite(user).then((response) => {
      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function activationLink(user) {
  return (dispatch) => {
    return serviceProvidersApi.activationLink(user).then((response) => {
      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-directory/store/actions.js